import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'a-center-container',
  template: '<ng-content></ng-content>',
  styleUrls: ['./a-center-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ACenterContainerComponent {}
